import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Progress,
  CardImg,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // Import the default calendar styles
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css"; // Import the styles
import { api } from "../../../api";
import Cookies from "js-cookie";

// Add the goodMessageStyle constant at the top of the file
const goodMessageStyle = `
.good-message {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #d86f89;
  color: #222;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 10px;
  padding: 0.5em 1.5em;
  margin: 0 auto;
  white-space: nowrap;
  max-width: 100vw;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
`;

const calendarCustomStyle = `
.react-calendar__tile--active,
.react-calendar__tile--range,
.react-calendar__tile--rangeStart,
.react-calendar__tile--rangeEnd {
  background: #d86f89 !important;
  color: #fff !important;
}
`;

const Dashboard2 = () => {
  const [date, setDate] = useState(new Date());
  const [selectedDateLabel, setSelectedDateLabel] = useState("");
  const [isBirthday, setIsBirthday] = useState(false);
  const [timeOfDay, setTimeOfDay] = useState("");

  // Function to format the selected date label
  const getFormattedDateLabel = (date) => {
    // Customize the date label format as needed
    return `${date.toLocaleString("default", {
      month: "long",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };
  useEffect(() => {
    // Update the selected date label when the date changes
    setSelectedDateLabel(getFormattedDateLabel(date));
  }, [date]);

  const checkBirthday = (date) => {
    // Check if the selected date matches a predefined birthday (e.g., January 1)
    return date.getMonth() === 0 && date.getDate() === 1;
  };

  const getTimeOfDay = (date) => {
    const hour = date.getHours();

    if (hour >= 0 && hour < 12) {
      return "Morning🌞";
    } else if (hour >= 12 && hour < 18) {
      return "Afternoon⛅"; // Corrected to 'Afternoon'
    } else {
      return "Night🌙";
    }
  };

  const emp_id = Cookies.get("token");

  useEffect(() => {
    const label = getFormattedDateLabel(date);
    setSelectedDateLabel(label);

    // Check if it's the user's birthday
    setIsBirthday(checkBirthday(date));

    // Determine the time of day
    setTimeOfDay(getTimeOfDay(date));
  }, [date]);

  const [progressPercentage, setProgressPercentage] = useState(75);

  const [pcount, setPcount] = useState();
  const [loading, setLoading] = useState(true);
  const [countper, setcountper] = useState({
    pending: "",
    inprogress: "",
    completed: "",
  });

  // const [projects,setproject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id');
        const response = await api.get(`enggtaskcount.php?emp_id=${emp_id}&company_id=${company_id}`);
        setPcount(response.data);
        console.log(response.data);
        const completedcount = Math.floor(
          (response.data[0].completed_tasks / response.data[0].total_tasks) *
            100
        );
        const pendingcount = Math.floor(
          (response.data[0].todo_tasks / response.data[0].total_tasks) * 100
        );
        const inprogresscount = Math.floor(
          (response.data[0].in_progress_tasks / response.data[0].total_tasks) *
            100
        );
        console.log(completedcount + "" + pendingcount + "" + inprogresscount);
        setcountper({
          pending: pendingcount,
          inprogress: inprogresscount,
          completed: completedcount,
        });
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  console.log(countper);

  const [projects, setproject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id');
        const response = await api.get(
          `viewProjectDetails.php?emp_id=${emp_id}&company_id=${company_id}`
        );
        setproject(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  console.log(projects);

  const [employees, setEmployees] = useState([]);
  const fetchEmployeeName = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.get(`employeeCalendar.php?company_id=${company_id}`);
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeName();
  }, []);

  useEffect(() => {
    const label = getFormattedDateLabel(date);
    setTimeOfDay(getTimeOfDay(date));
  }, [date, employees]);

  const isEmployeeBirthday = (date, employee) => {
    const employeeDOB = new Date(employee.dob);
    return (
      date.getDate() === employeeDOB.getDate() &&
      date.getMonth() === employeeDOB.getMonth()
    );
  };

  const isEmployeeWorkAnniversary = (date, employee) => {
    const anniversaryDate = new Date(employee.doj);
    return (
      date.getDate() === anniversaryDate.getDate() &&
      date.getMonth() === anniversaryDate.getMonth()
    );
  };

  // Helper for image path with environment check
  const getImagePath = (imageName) => {
    const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
    if (!imageName) return isProduction ? '/images/default-profile.png' : require('../../images/default-profile.png');
    return isProduction ? `/images/${imageName}` : require(`../../images/${imageName}`);
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row>
            {/* Completed Tasks Card */}
            <Col lg="6" xl="3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  borderRadius: "15px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                }}
              >
                <CardBody className="p-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h3 mb-0">Completed Task</CardTitle>
                    <span className="h3 font-weight-bold mb-0">
                      {pcount?.[0]?.completed_tasks || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Total Tasks Card */}
            <Col lg="6" xl="3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody className="p-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h3 mb-0">Total Task</CardTitle>
                    <span className="h3 font-weight-bold mb-0">
                      {pcount?.[0]?.total_tasks || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* To-do Tasks Card */}
            <Col lg="6" xl="3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody className="p-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h3 mb-0">To-do Task</CardTitle>
                    <span className="h3 font-weight-bold mb-0">
                      {pcount?.[0]?.todo_tasks || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* In-progress Tasks Card */}
            <Col lg="6" xl="3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody className="p-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h3 mb-0">Inprogress Task</CardTitle>
                    <span className="h3 font-weight-bold mb-0">
                      {pcount?.[0]?.in_progress_tasks || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col lg="7">
              {" "}
              {/* Adjust the column size to your preference */}
              {/* Your existing cards */}
              <Card
                className="card-stats mb-4 mb-xl-0 m-0"
                style={{ borderRadius: "20px" }}
              >
                <CardBody>
                  <Row>
                    <Col className="d-flex align-items-start text-center">
                      <div className="h1"> Overview</div>
                    </Col>
                    {/* <img
                                                src={require('../../project-management/assets/img/brand/WebDesignLayout-ezgif.com-crop (1).gif')}
                                                style={{ height: '100px', width: '200px', transform: 'scaleX(-1)' }}
                                                // transform: 'scaleX(-1)', 
                                                alt="Reversed Image"
                                            /> */}
                  </Row>
                </CardBody>
              </Card>
              {Array.isArray(projects) && projects.length > 0 ? (
                projects.map((project) => (
                  <Card
                    key={project.projectId}
                    className="card-stats mb-4 mb-xl-0 p-2 mt-3"
                    style={{
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      backgroundColor: "#fff",
                      borderRadius: "15px",
                    }}
                  >
                    <CardBody>
                      <Row>
                        {/* Circular Progress Bar on the Left */}
                        <Col xs="3" className="text-center">
                          <div style={{ width: "80px", height: "80px" }}>
                            <CircularProgressbar
                              value={project.progress}
                              text={`${project.progress}%`}
                              styles={buildStyles({
                                textColor: "blue",
                                pathColor: "#007bff",
                                trailColor: "#eee",
                              })}
                            />
                          </div>
                        </Col>

                        <Col xs="6" className="text-center">
                          <h3>{project.projectName}</h3>
                          <p>About: {project.description}</p>
                        </Col>

                        <Col xs="3" className="d-flex justify-content-end">
                          <div className="avatar-group d-flex">
                            {project.profile.images.map((image, index) => (
                              <div
                                className="avatar-group "
                                style={{ height: "40px", width: "25px" }}
                                key={index}
                              >
                                <a
                                  className="avatar avatar-sm "
                                  href="#pablo"
                                  id={`tooltip-${project.projectId}-${index}`}
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt={`Image ${index}`}
                                    className="rounded-circle"
                                    style={{ height: "35px", width: "35px" }}
                                    src={getImagePath(image)}
                                    onError={e => {
                                      const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
                                      e.target.onerror = null;
                                      e.target.src = isProduction ? '/images/default-profile.png' : require('../../images/default-profile.png');
                                    }}
                                  />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={`tooltip-${project.projectId}-${index}`}
                                >
                                  {project.profile.full_names[index]}
                                </UncontrolledTooltip>
                              </div>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                ))
              ) : (
                <div className="mt-4" style={{ textAlign: "center" }}>
                  No projects available
                </div>
              )}
            </Col>
            <Col lg="5">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: "1rem",
                  margin: 0,
                  width: "100%",
                  maxWidth: 420,
                  minWidth: 0,
                  alignSelf: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CardBody
                  style={{
                    padding: 0,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Row
                    style={{
                      margin: 0,
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <div className="col" style={{ textAlign: "center" }}>
                      <CardTitle
                        tag="h3"
                        className="text-uppercase text-muted mb-0"
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Calendar
                      </CardTitle>
                    </div>
                  </Row>
                  <Row
                    style={{
                      margin: 0,
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <Col
                      className="col-auto mt-2"
                      style={{
                        padding: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          maxWidth: 340,
                          minWidth: 0,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Calendar
                          style={{ width: "100%" }}
                          onChange={setDate}
                          value={date}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <p>Selected Date: {selectedDateLabel}</p>
                      {isBirthday && (
                        <div>
                          <Row>
                            <Col className="col-auto">
                              {/* Add the image on one side */}
                              <img
                                src="path/to/birthday_image.jpg"
                                alt="Birthday"
                                style={{
                                  width: "100px", // Set the width of the image
                                  height: "100px", // Set the height of the image
                                  borderRadius: "50%", // Make it a circular image
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      )}
                      <style>{goodMessageStyle}</style>
                      <style>{calendarCustomStyle}</style>
                      {timeOfDay && (
                        <div style={{ textAlign: "center", marginTop: 16 }}>
                          <div className="good-message">Good {timeOfDay}</div>
                        </div>
                      )}
                    </Col>
                  </Row>

                  {/* Birthday and Anniversary */}

                  {employees.some(
                    (employee) =>
                      isEmployeeBirthday(date, employee) ||
                      isEmployeeWorkAnniversary(date, employee)
                  ) && (
                    <>
                      {employees.map((employee, index) => {
                        if (
                          isEmployeeBirthday(date, employee) &&
                          isEmployeeWorkAnniversary(date, employee)
                        ) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "10px",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Birthday & Work Anniversary"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onError={e => {
                                    const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
                                    e.target.onerror = null;
                                    e.target.src = isProduction ? '/images/default-profile.png' : require('../../images/default-profile.png');
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Happy Birthday & Work Anniversary!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  Double celebration! Wishing you a day filled
                                  with joy, laughter, and all the things you
                                  love.
                                </p>
                              </Col>
                            </Row>
                          );
                        } else if (isEmployeeBirthday(date, employee)) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "10px",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Birthday"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onError={e => {
                                    const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
                                    e.target.onerror = null;
                                    e.target.src = isProduction ? '/images/default-profile.png' : require('../../images/default-profile.png');
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Happy Birthday!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  Wishing you a day filled with joy, laughter,
                                  and all the things you love!
                                </p>
                              </Col>
                            </Row>
                          );
                        } else if (isEmployeeWorkAnniversary(date, employee)) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "10px",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Work Anniversary"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onError={e => {
                                    const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
                                    e.target.onerror = null;
                                    e.target.src = isProduction ? '/images/default-profile.png' : require('../../images/default-profile.png');
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Congratulations on your work anniversary!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  It's been a pleasure having you on the team.
                                  Your hard work and dedication are appreciated.
                                </p>
                              </Col>
                            </Row>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </>
                  )}

                  {/* ... Your existing code ... */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Dashboard2;
